import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { listSchedulerCrew, ListSchedulerCrew$Params } from '../../../api/scheduler/functions';
import { updateSchedulerCrew, updateSchedulerCrewStatus } from '../../../api/scheduler/functions';
import { GetSchedulerCrewResponse } from '../../../api/scheduler/models/get-scheduler-crew-response';
import { SchedulerCrewResponse } from '../../../api/scheduler/models/scheduler-crew-response';
import { UpdateSchedulerCrewRequest } from '../../../api/scheduler/models/update-scheduler-crew-request';
import { UpdateSchedulerCrewStatusRequest } from '../../../api/scheduler/models/update-scheduler-crew-status-request';
import { SchedulerApiConfiguration } from '../../../api/scheduler/scheduler-api-configuration';

@Injectable({ providedIn: 'root' })
export class SchedulerCrewApiService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(SchedulerApiConfiguration);

  list(params?: ListSchedulerCrew$Params): Observable<GetSchedulerCrewResponse> {
    return listSchedulerCrew(this.http, this.config.rootUrl, params).pipe(map((res) => res.body));
  }

  update(id: number, body: UpdateSchedulerCrewRequest): Observable<SchedulerCrewResponse> {
    return updateSchedulerCrew(this.http, this.config.rootUrl, { id, body }).pipe(
      map((res) => res.body)
    );
  }

  updateStatus(
    id: number,
    body: UpdateSchedulerCrewStatusRequest
  ): Observable<SchedulerCrewResponse> {
    return updateSchedulerCrewStatus(this.http, this.config.rootUrl, { id, body }).pipe(
      map((res) => res.body)
    );
  }
}
